// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/MailTuile.js
//  MailTuile
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function MailTuile({ label, valeur, couleur, aide }) {
  return (
    <div title={aide} style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 11, padding: "12px 14px" }}>
      <div style={{ color: THEME.textDim, fontSize: 10.5, fontWeight: 800, letterSpacing: ".09em", textTransform: "uppercase" }}>{label}</div>
      <div style={{ color: couleur, fontSize: 22, fontWeight: 800, marginTop: 3 }}>{valeur}</div>
    </div>
  );
}
